export var CONTAINER_CLASS = 'g2-crosshair';
export var CROSSHAIR_LINE = CONTAINER_CLASS + "-line";
export var CROSSHAIR_TEXT = CONTAINER_CLASS + "-text";